module.exports = __webpack_public_path__ + "img/sand-1.2426358d.png";